import { combineReducers } from 'redux';

import ui from './ui';

/**
 * @typedef {{
 *   ui: import('./ui').DealerConfigurationAdministrationUIReducer,
 * }} DealerConfigurationGeneralReducer
 */
export default combineReducers({
  ui,
});
